import { render, staticRenderFns } from "./FabricMaterialEdit.vue?vue&type=template&id=3b318294&"
import script from "./FabricMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./FabricMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports